const isRemote = () => window.partner === "remote" || window.location.pathname.slice(0, 7) === "/remote";

export default isRemote;
